const defaults = {
	callback: function (response) {},
	distance: 50,
	container: jQuery(document),
};

export default class InfiniteLoad {
	constructor(options) {
		options.data = Object.assign(
			{ page: 1, postsPerPage: 6, type: "button" },
			options.data
		);
		this.options = options;
		this.loading = false;
		this.hasNext = true;

		this.prevScrollPos = this.getScrollPos();
		this.scroller = {
			options: Object.assign(defaults, this.options),
		};

		this.handleScroll = this.handleScroll.bind(this);
	}

	setFilters(data) {
		this.options.data.filters = data;
		this.hasNext = undefined;
	}

	resetFilters() {
		this.options.data.filters = {};
	}

	infiniteScroll() {
		if (this.options.type === "scroll") {
			window.addEventListener(
				"scroll",
				(event) => this.handleScroll(this.scroller, event),
				{ passive: true }
			);
			// For touch devices, try to detect scrolling by touching
			document.addEventListener("touchmove", (event) =>
				this.handleScroll(this.scroller, event)
			);
		} else {
			if (!!this.options.button) {
				this.options.button.addEventListener("click", () => {
					this.load();
				});
			}
		}
	}

	load() {
		if (this.loading || this.hasNext === false) return;
		this.loading = true;
		if (this.options.button) {
			this.options.button.classList.add("loading");
		}
		this.scroller.options.container.addClass("post-grid--is-loading");

		this.options.callback(this.options.data, (response) => {
			this.options.data.page++;
			this.loading = false;
			this.hasNext = response.has_next;

                if (this.options.button) {
                    this.options.button.classList.remove("loading");
                }
                this.scroller.options.container.removeClass(
                    "post-grid--is-loading"
                );

		});

	}

	reset() {
		this.options.data.page = 0;
	}

	getScrollPos() {
		return window.pageYOffset;
	}

	// Respond to scroll events
	handleScroll(scroller, event) {
		if (this.loading || this.hasNext === false) {
			return;
		}
		const scrollPos = this.getScrollPos();
		if (scrollPos === this.prevScrollPos) {
			return; // nothing to do
		}

		const container = scroller.options.container;
		const topOffset = container.is(document) ? 0 : container.offset().top;
		const outerHeight = container.outerHeight();

		// Check if scroll bar position is just the defined pixels above the max, if yes, initiate an update
        if (scrollPos >= topOffset + outerHeight - window.innerHeight + 120) {
			this.load();
		}

		this.prevScrollPos = scrollPos;
	}
}
